import type { SpringValue } from '@react-spring/web';
import { animated } from '@react-spring/web';

import { classFilter } from '@shieldpay/theme-provider-ui/utilities';
import type { ToastContent } from '@shieldpay/toast-rack-provider-ui';
import { isDecoratedToastContent } from '@shieldpay/toast-rack-provider-ui';

import { Card } from '../card/card';
import { Text } from '../text/text';

import * as styles from './notification.css';

interface NotificationProps {
  children: ToastContent;
  style: Record<string, SpringValue>;
  'data-testid'?: string;
}

export const Notification = ({
  children,
  style,
  'data-testid': testId,
}: NotificationProps) => {
  const { text, icon } = isDecoratedToastContent(children)
    ? children
    : { text: children, icon: null };

  return (
    <Card
      className={classFilter([
        styles.notification,
        !isDecoratedToastContent(children) && styles.noIcon,
      ])}
      Component={animated.div}
      role="alert"
      spacing="baseNeg3"
      padding={{ x: 'basePos3', y: 'basePos1' }}
      stack="row"
      style={style}
      variant="darkShadow"
      background="neutral150"
      data-testid={testId}
    >
      {icon}
      <Text paragraph>{text}</Text>
    </Card>
  );
};
